export enum PaymentStatusEnum {
  SUCCESS= 'success',
  FAILURE = 'failure',
}
